export default {
  'flow-commission': 'Flow Commission',
  'copy-trader-id': 'Copy Trader ID',
  'signal-source-id': 'Signal Source ID',
  'subscription-time': 'Subscription Time',
  'fee-type': 'Fee Type',
  'copy-trade-fee': 'Copy Trade Fee',
  'rebate-formula': 'Rebate Formula',
  'rebate-amount': 'Rebate Amount',
  'total-rebate-amount': 'Total Rebate Amount',
  'commission-paid-amount': 'Commission Paid Amount',
  'frozen-commission-amount': 'Frozen Commission Amount',
  status: 'Status',
}
